// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"553":"b82f5c7a","977":"927dd47f"}[chunkId] + ".chunk.js");